import React from "react";
import { useField, useForm } from "@formily/react";
import { theme as antdTheme } from "antd";

// TODO Add a twmerge or clsx library to handle className merging, but also check if CustomClassnames are still the way to go

interface RumbleLabelProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
  className?: string;
}

export const RumbleLabel: React.FC<RumbleLabelProps> = ({
  children,
  className,
  ...props
}) => {
  // Hooks are kept for possible future use
  useField();
  useForm();

  const {
    token: { CustomClassnames = {} },
  } = antdTheme.useToken() as {
    token: { CustomClassnames?: { RumbleLabel?: string } };
  };

  const combinedClassName = [className, CustomClassnames.RumbleLabel]
    .filter(Boolean)
    .join(" ");

  return (
    <span {...props} className={combinedClassName}>
      {children}
    </span>
  );
};
